// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1HrZE","log":"ModalInventoryLogs_log__2HT4P","date":"ModalInventoryLogs_date__batOA","userName":"ModalInventoryLogs_userName__22fQA"};